const date = new Date().getFullYear();
export const variables = {
  // BASE_URL: 'https://simplisafeportal-dev.corecentricsolutions.com/api/',
  // BASE_URL: 'https://SS-PortalAPI-UAT.corecentricsolutions.com/api/', // UAT  URl
  BASE_URL: 'https://ss-portalapi-prod.corecentricsolutions.com/api/', // Prod API
  FILE_URL: `${`${window.location.protocol}//${window.location.host}`}/functionalTesting/`,
  COPYRIGHT: `${date} @CoreCentric Solutions.inc`,
  PROCESSNAME: 'SimpliSafePortal',
  IMAGE_URL: `${`${window.location.protocol}//${window.location.host}`}/SSImageCapture/`,
};
